import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "user-name" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "name" }
const _hoisted_5 = {
  key: 0,
  class: "desc"
}

import { onBeforeUnmount, PropType, ref } from 'vue';

import actions from '@/shared/actions';


export default /*@__PURE__*/_defineComponent({
  __name: 'Setting',
  props: {
  userInfo: {
    type: Object as PropType<Project.IUserInfo>,
    default: () => {
      return {};
    }
  },
  roleName: {
    type: String,
    default: ''
  }
},
  emits: ['logout'],
  setup(__props, { emit: __emit }) {



const emits = __emit;

const showUser = ref(false);

// 处理名字过长
const handleName = (str: string) => {
  if (!str) return;
  return str.length > 6 ? `${str.slice(0, 6)}...` : str;
};

const logout = () => {
  emits('logout');
};

onBeforeUnmount(() => {
  actions.offGlobalStateChange();
});

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    placement: "bottom-end",
    "popper-class": "profile-popover",
    width: "180",
    trigger: "click",
    "visible-arrow": false,
    onShow: _cache[0] || (_cache[0] = ($event: any) => (showUser.value = !showUser.value)),
    onHide: _cache[1] || (_cache[1] = ($event: any) => (showUser.value = !showUser.value))
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["arrow user-info", showUser.value ? 'up' : ''])
      }, [
        _createElementVNode("img", {
          class: "user-avatar",
          src: __props.userInfo.avatar
        }, null, 8, _hoisted_1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(handleName(__props.userInfo.userName)), 1),
        _cache[2] || (_cache[2] = _createElementVNode("img", {
          class: "arrow-icon",
          src: "https://cdn.cnbj3-fusion.fds.api.mi-img.com/ecy-icon-svg/svg/symbol-fill-chevron-down.svg"
        }, null, -1))
      ], 2)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["profile-box", showUser.value ? 'show' : ''])
      }, [
        _createElementVNode("img", {
          class: "profile-avatar",
          src: __props.userInfo.avatar
        }, null, 8, _hoisted_3),
        _createElementVNode("p", _hoisted_4, _toDisplayString(__props.userInfo.userName), 1),
        (__props.roleName)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.roleName), 1))
          : _createCommentVNode("", true),
        _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "sep-line" }, null, -1)),
        _createElementVNode("div", {
          class: "qk-dropdown__menu-item",
          onClick: logout
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('global.logout')), 1)
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})